module.exports = __webpack_public_path__ + "img/1506786262.119c43e5.jpg";